import React from 'react';
import {
    Datagrid,
    DateField,
    List,
    TextField,
} from 'react-admin'

export const CodeConsumptionList = props => (
    <List {...props} bulkActionButtons={false}>
        <Datagrid>
            <TextField label="Code" source="code" />
            <TextField label="Platform" source="platform" />
            <TextField label="Consumer Id" source="consumerId" />
            <TextField label="IP Address" source="ipAddress" />
            <TextField label="Country Code" source="countryCode" />
            <DateField label="Date Consumed" source="dateConsumed" showTime />
        </Datagrid>
    </List>
);